import { Grid, Paper } from "@mui/material";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  Polyline,
  useLoadScript,
} from "@react-google-maps/api";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { addressNotAvailableMsg, fetchingAddressMsg, noInternetMsg, serverMsg } from "../../config/messageconstant";
import {
  default as checkInImg,
  default as image10,
} from "../../Images/check_in.png";

import uniqueUser from "../../Images/uniqueUser.png";

import distributorImg from "../../Images/distributor.png";
import checkOutImg from "../../Images/imageRed.png";
import jointWorkImg from "../../Images/joint_work.png";
import locationMan from "../../Images/locationMan.png";
import newUsers from "../../Images/newUsers.png";
import officeWorkImg from "../../Images/office_work.png";
import otherWorkImg from "../../Images/other_work.png";
import retailingImg from "../../Images/retailing.png";
import unVisitedOutletIcon from "../../Images/UnvisitedOutletsIcon.png";
import zeroOrderIconImg from "../../Images/zeroOrderIcon.png";
import houseImg from "../../Images/house.png";
import {
  showLoador,
  showNotification,
} from "../../Pages/Landing/Landing.slice";
import {
  getDateWiseBeatAndOutlets,
  getTimeLineForBelowSalesTeamsAndDates,
} from "../../Slice/managerLogs.slice";
import Timeline from "./Timeline";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import { googleApiKey } from "../../config/Url";

dayjs.extend(duration);

const GMapWithFunctionality = ({
  showLoador,
  showNotification,
  getTimeLineForBelowSalesTeamsAndDates,
  getDateWiseBeatAndOutlets,
  mainHeight = "90vh",
  mapHeight = "100%",
  showBackBtn = true,
}) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDvKXkZ-S03qxR-8b8HLnCOKr36eYRxC2k",
  });

  const params = useParams();
  const [mapRef, setMapRef] = useState(null);
  const [personMarkers, setPersonMarkers] = useState([]);
  const [activityMarkers, setActivityMarkers] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const [currentPosition, setCurrentPosition] = useState(null);
  const [animationProgress, setAnimationProgress] = useState(0);
  const [speedMultiplier, setSpeedMultiplier] = useState(1); // 1x, 3x speed multiplier
  const [checkInLat, setCheckInLat] = useState(22.9447827);
  const [checkInLong, setCheckInLong] = useState(72.6682403);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedDot, setSelectedDot] = useState(null);
  const [selectedPath, setSelectedPath] = useState([]);
  const [openInfoWindows, setOpenInfoWindows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [outletMarkers, setOutletMarkers] = useState([]);
  const [outletPath, setOutletPath] = useState([]);
  const [selectedOutletId, setSelectedOutletId] = useState(null);
  const [isTrackSelected, setIsTrackSelected] = useState(false);
  const [infoWindowData, setInfoWindowData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [distanceFromOutlet, setDistanceFromOutlet] = useState("");
  const [timelineAndMapOpenFlag, setTimelineAndMapOpenFlag] = useState(false);
  const [timelineDataForManager, setTimelineDataForManager] = useState([]);
  const [checkInAddress, setCheckInAddress] = useState("");
  const [dotAddress, setDotAddress] = useState("");
  const [salesTeamAddress, setSalesTeamAddress] = useState({});
  const [showDistanceFromOutlet, setShowDistanceFromOutlet] = useState("");
  const [checkboxValue, setCheckboxValue] = useState(10);
  const [showTrackingWithActivity, setShowTrackingWithActivity] =
    useState(false);
  const [showTimelineManagerLogs, setShowTimelineManagerLogs] = useState("");
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("DD-MM-YYYY")
  );
  const [timelinePathCoords, setTimelinePathCoords] = useState([]);
  const [hideOnLoadTimeDelayPopUp, setHideOnLoadTimeDelayPopUp] =
    useState(false);

  const [homeMarker, setHomeMarker] = useState(null);
  const pendingTimelineResponseRef = useRef(null);
  const isLoadedRef = useRef(false);

  useEffect(() => {
    isLoadedRef.current = isLoaded;
    if (isLoaded) {
      tryApplyPendingTimelineData();
    }
  }, [isLoaded]);

  useEffect(() => {
    if (!mapRef || !searchTerm) return;

    const found = personMarkers.find(
      (m) => m.employeeCode?.toLowerCase() == searchTerm.toLowerCase()
    );

    if (found) {
      mapRef.panTo({ lat: found.lat, lng: found.lng });
      mapRef.setZoom(15);
    }
  }, [searchTerm, mapRef, personMarkers]);

  useEffect(() => {
    if (!isLoaded) return;

    if (pendingTimelineResponseRef.current) {
      tryApplyPendingTimelineData();
      return;
    }

    fetchInitialMapData();
  }, [isLoaded]);

  useEffect(() => {
    if (!mapRef || personMarkers.length === 0) return;

    const bounds = new window.google.maps.LatLngBounds();
    personMarkers.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
    mapRef.fitBounds(bounds);
  }, [personMarkers, mapRef]);

  useEffect(() => {
    if (
      (
        checkboxValue == 0 ||
        checkboxValue == 2 ||
        checkboxValue == 3
      ) &&
      selectedPath.length > 0 &&
      mapRef
    ) {
      const lastPoint = selectedPath[selectedPath.length - 1];
      mapRef.panTo({ lat: lastPoint.lat, lng: lastPoint.lng });
      mapRef.setZoom(15);
    }
  }, [selectedPath, checkboxValue, mapRef]);

  const handleMarkerClicks = (clickedMarker) => {
    setPersonMarkers((prev) =>
      prev.map((m) =>
        m.id === clickedMarker.id ? { ...m, isFrozen: true } : m
      )
    );
    setOpenInfoWindows((prev) =>
      prev.includes(clickedMarker.id) ? prev : [...prev, clickedMarker.id]
    );
  };

  const applyTimelineResponseToMap = (response) => {
    const salesTeamId = params.id;
    let personMarkers = [];
    let activityMarkers = [];
    let timelineData = [];

    response.forEach((salesPerson) => {
      if (salesPerson.managerLogs && salesPerson.managerLogs.length > 0) {
        const latestLog =
          salesPerson.managerLogs[salesPerson.managerLogs.length - 1];

        const lat = parseFloat(
          latestLog.managerEndLat || latestLog.managerStartLat
        );
        const lng = parseFloat(
          latestLog.managerEndLong || latestLog.managerStartLong
        );

        if (!isNaN(lat) && !isNaN(lng)) {
          personMarkers.push({
            id: salesPerson.id,
            name: salesPerson.name,
            lat,
            lng,
            logs: salesPerson.managerLogs,
            employeeCode: salesPerson.employeeCode,
            icon: salesPerson.id == salesTeamId ? uniqueUser : newUsers,
          });

          const firebaseList = salesPerson.managerLogs
            .filter((row) => row.flag == 1)
            .map((locObject, index) => ({
              index: index + 1,
              id: locObject.id,
              name: salesPerson.name || locObject.name || "-",
              address:
                locObject.checkInOut == 1
                  ? locObject.endAddress
                  : locObject.startAddress,
              lat:
                locObject.checkInOut == 1
                  ? +locObject.managerEndLat
                  : +locObject.managerStartLat,
              lng:
                locObject.checkInOut == 1
                  ? +locObject.managerEndLong
                  : +locObject.managerStartLong,
              icon:
                locObject.otherTaskId != null
                  ? locObject.otherTaskId == 1
                    ? locObject.isVisitIsOrder == 0
                      ? retailingImg
                      : zeroOrderIconImg
                    : locObject.otherTaskId == 2 &&
                      locObject.workingTypeId !== 5
                      ? distributorImg
                      : locObject.otherTaskId == 3
                        ? officeWorkImg
                        : locObject.otherTaskId == 4
                          ? jointWorkImg
                          : locObject.otherTaskId == 5 && locObject.checkInOut == 0
                            ? checkInImg
                            : locObject.otherTaskId == 5 && locObject.checkInOut == 1
                              ? checkOutImg
                              : otherWorkImg
                  : "",
              iconId:
                locObject.otherTaskId != null
                  ? locObject.otherTaskId == 1
                    ? locObject.isVisitIsOrder == 0
                      ? "2"
                      : "3"
                    : locObject.otherTaskId == 2 &&
                      locObject.workingTypeId !== 5
                      ? "6"
                      : locObject.otherTaskId == 3
                        ? "5"
                        : locObject.otherTaskId == 4
                          ? "7"
                          : locObject.otherTaskId == 5 && locObject.checkInOut == 0
                            ? "1"
                            : locObject.otherTaskId == 5 && locObject.checkInOut == 1
                              ? "8"
                              : "4"
                  : "",
              amount:
                locObject.isVisitIsOrder == 0
                  ? !isNaN(parseFloat(locObject.description)) &&
                    isFinite(locObject.description)
                    ? parseFloat(locObject.description).toFixed(2)
                    : "0"
                  : "0",
              workingTypeId: locObject.workingTypeId,
              startTime: locObject.fromTime,
              endTime: locObject.toTime,
              outletName: locObject.entityName,
              remoteOrder: locObject.remoteOrder,
              checkInOut: locObject.checkInOut,
              outletLat: locObject.outletLatitude,
              outletLong: locObject.outletLongitude,
            }));

          activityMarkers.push(...firebaseList);
          timelineData.push(salesPerson);
        }
      }
    });

    setPersonMarkers(personMarkers);
    setActivityMarkers(activityMarkers);
    setTimelineDataForManager(timelineData);
    setOpenInfoWindows(personMarkers.map((m) => m.id));
    setTimelineAndMapOpenFlag(true);

    if (personMarkers.length > 0 && mapRef) {
      const bounds = new window.google.maps.LatLngBounds();
      personMarkers.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
      mapRef.fitBounds(bounds);

      setCheckInLat(personMarkers[0].lat);
      setCheckInLong(personMarkers[0].lng);
    }
  };

  const tryApplyPendingTimelineData = () => {
    if (!isLoadedRef.current || !pendingTimelineResponseRef.current) return;

    const response = pendingTimelineResponseRef.current;
    pendingTimelineResponseRef.current = null;
    applyTimelineResponseToMap(response);
  };

  const handleInitialTimelineData = (response) => {
    pendingTimelineResponseRef.current = response;
    tryApplyPendingTimelineData();
  };

  const fetchInitialMapData = async () => {
    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    const showTimelineManagerSettingKey = localStorage.getItem(
      "showTimelineManagerLogsWise"
    );

    setShowTimelineManagerLogs(showTimelineManagerSettingKey);

    const showRealTimeTracking = localStorage.getItem("showRealTimeTracking");
    if (showRealTimeTracking == 1 && showTimelineManagerSettingKey == 1) {
      return;
    }

    showLoador({ loador: true });

    const salesTeamId = params.id;

    await getTimeLineForBelowSalesTeamsAndDates({
      fromDate: dayjs().format("DD-MM-YYYY"),
      toDate: dayjs().format("DD-MM-YYYY"),
      salesTeamId: salesTeamId,
      flag: 0,
    }).then(({ response, success }) => {
        if (!success || !response) {
        showNotification({ msg: serverMsg, severity: "error" });
        return;
      }
      
      applyTimelineResponseToMap(response);
    });
    showLoador({ loador: false });
  };

  const onActivitySelect = (activities) => {
    setSelectedActivities(activities);

    if (activities.length > 0) {
      const selectedIcon = activities[activities.length - 1];

      const selectedMarker = activityMarkers.find(
        (m) => m.icon == selectedIcon
      );

      if (selectedMarker) {
        mapRef.panTo({
          lat: selectedMarker.lat,
          lng: selectedMarker.lng,
        });
        setTimeout(() => {
          mapRef.setZoom(17);
        }, 300);
      }
    }
  };

  const onMapLoad = (map) => {
    setMapRef(map);

    if (personMarkers.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      personMarkers.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
      map.fitBounds(bounds);
    } else {
      map.setCenter({ lat: checkInLat, lng: checkInLong });
      map.setZoom(6);
    }
  };

  const handleMarkerClick = (marker) => {
    if (selectedMarker && selectedMarker.id === marker.id) {
      setSelectedMarker(null);
      setSelectedPath([]);
      setSelectedDot(null);
      return;
    }

    if (!marker.logs || marker.logs.length === 0) return;

    const sortedLogs = [...marker.logs].sort(
      (a, b) =>
        dayjs(a.insertTime, "DD-MM-YYYY HH:mm:ss") -
        dayjs(b.insertTime, "DD-MM-YYYY HH:mm:ss")
    );

    let pathCoords = sortedLogs
      .map((log) => {
        const lat =
          log.checkInOut === 1
            ? parseFloat(log.managerEndLat)
            : parseFloat(log.managerStartLat);
        const lng =
          log.checkInOut === 1
            ? parseFloat(log.managerEndLong)
            : parseFloat(log.managerStartLong);

        if (!isNaN(lat) && !isNaN(lng)) {
          return {
            lat,
            lng,
            flag: log.flag,
            insertTime: dayjs(log.insertDateTime, "DD-MM-YYYY HH:mm:ss").format(
              "HH:mm:ss"
            ),
          };
        }
        return null;
      })
      .filter(Boolean);

    let stoppageObj = {};

    const isShowTimelineMapStoppage = localStorage.getItem(
      "isShowTimelineMapStoppage"
    );
    stoppageObj = isShowTimelineMapStoppage
      ? JSON.parse(isShowTimelineMapStoppage)
      : {};

    const stopMin = (stoppageObj?.stoptime || 0) / 60;

    pathCoords = pathCoords.map((point, i, arr) => {
      if (i > 0) {
        const start = dayjs(arr[i - 1].insertTime, "HH:mm:ss");
        const end = dayjs(point.insertTime, "HH:mm:ss");
        const diffMinutes = dayjs.duration(end.diff(start)).asMinutes();
        return {
          ...point,
          gapTime: diffMinutes,
          isGap: diffMinutes > stopMin,
          prevTime: arr[i - 1].insertTime,
        };
      }
      return point;
    });

    const timeDelayListToShowOnTimeline = pathCoords.filter(
      (point) => point.isGap
    );

    setTimelinePathCoords(timeDelayListToShowOnTimeline);
    setSelectedMarker(marker);
    setSelectedPath(pathCoords);
    setOpenInfoWindows((prev) =>
      prev.includes(marker.id) ? prev : [...prev, marker.id]
    );
  };

  const handleIconMarkerClick = (data) => {
    const {
      index,
      id,
      lat,
      lng,
      address,
      amount,
      workingTypeId,
      startTime,
      endTime,
      outletName,
      insertTime,
      remoteOrder,
      checkInOut,
      outletLat,
      outletLong,
    } = data;

    if (workingTypeId == 5) {
      checkInOutAddressHandler({ managerStartLat: lat, managerStartLong: lng });
    } else if (outletLat && outletLong) {
      distanceCalculatorHandler(
        { latitude: lat, longitude: lng },
        { latitude: outletLat, longitude: outletLong }
      );
    }

    setInfoWindowData({
      index,
      id,
      address,
      amount,
      workingTypeId,
      startTime,
      endTime,
      outletName,
      insertTime,
      remoteOrder,
      checkInOut,
      outletLat,
      outletLong,
    });
    setIsOpen(true);
    mapRef?.panTo({ lat, lng });
  };

  const getTimeBetweenCords = (path) => {
    let stoppageObj = {};

    const isShowTimelineMapStoppage = localStorage.getItem(
      "isShowTimelineMapStoppage"
    );
    stoppageObj = isShowTimelineMapStoppage
      ? JSON.parse(isShowTimelineMapStoppage)
      : {};

    const stopMin = (stoppageObj?.stoptime || 0) / 60;

    return path.slice(0, -1).map((point, i) => {
      const next = path[i + 1];

      const start = dayjs(point.insertTime, "HH:mm:ss");
      const end = dayjs(next.insertTime, "HH:mm:ss");
      const diffMinutes = dayjs.duration(end.diff(start)).asMinutes();

      let color = "blue";
      let showGap = false;

      if (stoppageObj.identify_stops == true) {
        if (
          (stoppageObj.withActivity || (point.flag == 0 && next.flag == 0)) &&
          diffMinutes > stopMin
        ) {
          color = "red";
          showGap = true;
        }
      }

      return {
        coords: [point, next],
        color,
        showGap,
        gapTime: diffMinutes,
        gapLocation: next,
      };
    });
  };

  const getDistance = (p1, p2) => {
    const R = 6371; // km
    const dLat = (p2.latitude - p1.latitude) * (Math.PI / 180);
    const dLng = (p2.longitude - p1.longitude) * (Math.PI / 180);
    const lat1 = p1.latitude * (Math.PI / 180);
    const lat2 = p2.latitude * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // distance in km
  };

  const rearrangeOutlets = async (outlets, startPoint = null) => {
    if (outlets.length === 0) return [];

    const remaining = [...outlets];
    const ordered = [];

    let current;
    if (startPoint) {
      current = startPoint;
    } else {
      current = remaining.shift();
    }

    ordered.push(current);

    while (remaining.length > 0) {
      let nearestIndex = -1;
      let minDistance = Infinity;

      for (let i = 0; i < remaining.length; i++) {
        const outlet = remaining[i];
        const distance = getDistance(
          { latitude: current.lat, longitude: current.lng },
          { latitude: outlet.lat, longitude: outlet.lng }
        );

        if (distance < minDistance) {
          minDistance = distance;
          nearestIndex = i;
        }
      }

      current = remaining.splice(nearestIndex, 1)[0];
      ordered.push(current);
    }

    return ordered;
  };

  const handleRouteClick = async () => {
    if (outletMarkers.length > 0) {
      setOutletMarkers([]);
      setOutletPath([]);
      return;
    }

    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    showLoador({ loador: true });

    await getDateWiseBeatAndOutlets({
      date: selectedDate,
      salesTeamId: params.id,
    }).then(async ({ response, success }) => {
      showLoador({ loador: false });

      if (!success || !response) {
        showNotification({ msg: serverMsg, severity: "error" });
        return;
      }

      const outletLogs = response.flatMap((beat) => beat.outletLogsList || []);

      const validOutlets = outletLogs
        .filter(
          (o) =>
            o.latitude &&
            o.longitude &&
            !isNaN(parseFloat(o.latitude)) &&
            !isNaN(parseFloat(o.longitude))
        )
        .map((o) => ({
          id: o.outletId,
          lat: parseFloat(o.latitude),
          lng: parseFloat(o.longitude),
          firmName: o.firmName,
          outletCode: o.outletCode,
          status: o.status,
          icon:
            o.status == 0
              ? unVisitedOutletIcon
              : o.status == 1
                ? zeroOrderIconImg
                : retailingImg,
          beatName: o.beatName,
          checkInLat: o.checkInLat,
          checkInLong: o.checkInLong,
          checkInTime: o.checkInTime,
        }));

      const checkIn = response.find(
        (beat) => beat.checkInLat && beat.checkInLong
      );

      let startPoint = null;
      if (checkIn) {
        startPoint = {
          id: "checkin-point",
          lat: parseFloat(checkIn.checkInLat),
          lng: parseFloat(checkIn.checkInLong),
          firmName: checkIn.beatName + " (Check-in)  ",
          outletCode: "",
          status: "checkin",
          icon: image10,
        };
      }

      const ordered = await rearrangeOutlets(validOutlets, startPoint);

      setOutletMarkers(ordered);
      setOutletPath(ordered.map((m) => ({ lat: m.lat, lng: m.lng })));

      if (ordered.length > 0 && mapRef) {
        const bounds = new window.google.maps.LatLngBounds();
        ordered.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
        mapRef.fitBounds(bounds);
      }
    });
  };

  const handleOutletsClick = async () => {
    if (outletMarkers.length > 0) {
      setOutletMarkers([]);
      setOutletPath([]);
      return;
    }

    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    showLoador({ loador: true });

    await getDateWiseBeatAndOutlets({
      date: selectedDate,
      salesTeamId: params.id,
    }).then(({ response, success }) => {
      showLoador({ loador: false });

      if (!success || !response) {
        showNotification({ msg: serverMsg, severity: "error" });
        return;
      }

      const outletLogs = response.flatMap((beat) => beat.outletLogsList || []);

      const markers = outletLogs
        .filter(
          (o) =>
            o.latitude &&
            o.longitude &&
            !isNaN(parseFloat(o.latitude)) &&
            !isNaN(parseFloat(o.longitude))
        )
        .map((o) => ({
          id: o.outletId,
          lat: parseFloat(o.latitude),
          lng: parseFloat(o.longitude),
          firmName: o.firmName,
          outletCode: o.outletCode,
          status: o.status,
          icon:
            o.status == 0
              ? unVisitedOutletIcon
              : o.status == 1
                ? zeroOrderIconImg
                : retailingImg,
        }));

      setOutletMarkers(markers);
      setOutletPath([]);

      if (markers.length > 0 && mapRef) {
        const bounds = new window.google.maps.LatLngBounds();
        markers.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
        mapRef.fitBounds(bounds);
      }
    });
  };

  const distanceCalculatorHandler = async (coord1, coord2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const lat1 = deg2rad(coord1.latitude);
    const lon1 = deg2rad(coord1.longitude);
    const lat2 = deg2rad(coord2.latitude);
    const lon2 = deg2rad(coord2.longitude);
    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers
    setDistanceFromOutlet(distance * 1000); // Convert to meters
    setShowDistanceFromOutlet(true);
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  const checkInOutAddressHandler = async (managerLogsObject) => {
    if (
      managerLogsObject?.managerStartLat &&
      managerLogsObject?.managerStartLong
    ) {
      const cacheKey = `${managerLogsObject.managerStartLat}_${managerLogsObject.managerStartLong}`;

      // Return cached address if already fetched for these coordinates
      if (salesTeamAddress[cacheKey]) {
        setCheckInAddress(salesTeamAddress[cacheKey]);
        return salesTeamAddress[cacheKey];
      }

      showLoador({ loador: true });
      const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${managerLogsObject.managerStartLat},${managerLogsObject.managerStartLong}&key=${googleApiKey}`;

      try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        showLoador({ loador: false });

        if (data.status === "OK" && data.results.length !== 0) {
          const address = data?.results?.[0]?.formatted_address ?? "";
          setSalesTeamAddress((prev) => ({ ...prev, [cacheKey]: address }));
          setCheckInAddress(address);
          return address;
        } else {
          setSalesTeamAddress((prev) => ({ ...prev, [cacheKey]: addressNotAvailableMsg }));
          setCheckInAddress(addressNotAvailableMsg);
          return addressNotAvailableMsg;
        }
      } catch (error) {
        showLoador({ loador: false });
        setCheckInAddress(addressNotAvailableMsg);
        return addressNotAvailableMsg;
      }
    }
    return "";
  };

  const handleTabData = async (latLongDataObject) => {
    const {
      id,
      managerStartLat,
      managerStartLong,
      workingTypeId,
      fromTime,
      toTime,
      entityName,
      remoteOrder,
      checkInOut,
      outletLat,
      outletLong,
      insertTime,
      value1,
    } = latLongDataObject;

    let address = "";
    if (workingTypeId == 5) {
      address = await checkInOutAddressHandler({
        managerStartLat,
        managerStartLong,
      });
    } else if (outletLat && outletLong) {
      distanceCalculatorHandler(
        { latitude: managerStartLat, longitude: managerStartLong },
        { latitude: outletLat, longitude: outletLong }
      );
    }

    setInfoWindowData({
      index: 0,
      id,
      address,
      amount: value1 || "0",
      workingTypeId,
      startTime: fromTime,
      endTime: toTime,
      outletName: entityName || "-",
      remoteOrder: remoteOrder || 0,
      checkInOut: checkInOut || 0,
      outletLat: outletLat,
      outletLong: outletLong,
      insertTime,
    });

    mapRef?.panTo({
      lat: +managerStartLat,
      lng: +managerStartLong,
    });

    setIsOpen(true);

    const selectedActivityMarker = activityMarkers.find((m) => m.id === id);
    if (!selectedActivityMarker) {
      const newActivityMarker = {
        index: 0,
        id,
        name: entityName || "-",
        address: address || "-",
        lat: +managerStartLat,
        lng: +managerStartLong,
        icon:
          workingTypeId == 5
            ? checkInOut == 0
              ? checkInImg
              : checkOutImg
            : workingTypeId == 1
              ? retailingImg
              : workingTypeId == 2
                ? distributorImg
                : workingTypeId == 3
                  ? officeWorkImg
                  : workingTypeId == 4
                    ? jointWorkImg
                    : otherWorkImg,
        amount: value1 || "0",
        workingTypeId,
        startTime: fromTime,
        endTime: toTime,
        outletName: entityName || "-",
        remoteOrder: remoteOrder || 0,
        checkInOut: checkInOut || 0,
        outletLat: outletLat,
        outletLong: outletLong,
      };
      setActivityMarkers((prev) => [...prev, newActivityMarker]);
    }
    setShowDistanceFromOutlet(true);
  };

  const handleTabDataForTimeDelay = async (latLongDataObject) => {
    const { lattitude, longittude, currentTime, gapTime } = latLongDataObject;

    mapRef?.panTo({
      lat: +lattitude,
      lng: +longittude,
    });

    let point = {
      lat: +lattitude,
      lng: +longittude,
      gapTime: gapTime,
      insertTime: currentTime,
      isGap: true,
    };
    setSelectedDot(point);
    setHideOnLoadTimeDelayPopUp(true);

    if (gapTime > 60) {
      const address = await checkInOutAddressHandler({
        managerStartLat: +lattitude,
        managerStartLong: +longittude,
      });
      setDotAddress(address);
    }
  };

  const onSearchData = (dataOnSearch) => {

    let firebaseList = [];
    if (dataOnSearch.length !== 0 && dataOnSearch[0].managerLogs) {
      dataOnSearch[0].managerLogs
        .filter((row) => row.flag == 1)
        .forEach((locObject, index) => {
          const locData = {
            index: index + 1,
            id: locObject.id,
            name: dataOnSearch[0].name || locObject.name || "-",
            address:
              locObject.checkInOut == 1
                ? locObject.endAddress
                : locObject.startAddress,
            lat:
              locObject.checkInOut == 1
                ? +locObject.managerEndLat
                : +locObject.managerStartLat,
            lng:
              locObject.checkInOut == 1
                ? +locObject.managerEndLong
                : +locObject.managerStartLong,
            icon:
              locObject.otherTaskId != null
                ? locObject.otherTaskId == 1
                  ? locObject.isVisitIsOrder == 0
                    ? retailingImg
                    : zeroOrderIconImg
                  : locObject.otherTaskId == 2 && locObject.workingTypeId !== 5
                    ? distributorImg
                    : locObject.otherTaskId == 3
                      ? officeWorkImg
                      : locObject.otherTaskId == 4
                        ? jointWorkImg
                        : locObject.otherTaskId == 5 && locObject.checkInOut == 0
                          ? checkInImg
                          : locObject.otherTaskId == 5 && locObject.checkInOut == 1
                            ? checkOutImg
                            : otherWorkImg
                : "",
            amount:
              locObject.isVisitIsOrder == 0
                ? !isNaN(parseFloat(locObject.description)) &&
                  isFinite(locObject.description)
                  ? parseFloat(locObject.description).toFixed(2)
                  : "0"
                : "0",
            workingTypeId: locObject.workingTypeId,
            startTime: locObject.fromTime,
            endTime: locObject.toTime,
            outletName: locObject.entityName,
            remoteOrder: locObject.remoteOrder,
            checkInOut: locObject.checkInOut,
            outletLat: locObject.outletLatitude,
            outletLong: locObject.outletLongitude,
          };
          firebaseList.push(locData);
        });
    }

    const latestLog = firebaseList[firebaseList.length - 1] || {
      lat: checkInLat,
      lng: checkInLong,
    };
    const personMarker = {
      id: dataOnSearch[0].id,
      name: dataOnSearch[0].name,
      lat: latestLog.lat,
      lng: latestLog.lng,
      logs: dataOnSearch[0].managerLogs,
      employeeCode: dataOnSearch[0].employeeCode,
      icon: dataOnSearch[0].id == params.id ? uniqueUser : newUsers,
    };

    setPersonMarkers([personMarker]);
    setActivityMarkers(firebaseList);
    setTimelineDataForManager(dataOnSearch);
    setCheckInLat(firebaseList.length !== 0 ? firebaseList[0].lat : checkInLat);
    setCheckInLong(
      firebaseList.length !== 0 ? firebaseList[0].lng : checkInLong
    );

    setOpenInfoWindows([personMarker.id]);
    setTimelineAndMapOpenFlag(true);

    if (firebaseList.length > 0 && mapRef) {
      mapRef.panTo({ lat: personMarker.lat, lng: personMarker.lng });
      mapRef.setZoom(15);
      handleMarkerClicks(personMarker);
    }

    setOutletMarkers([]);
    setOutletPath([]);
    handleMarkerClick([]);
    setSelectedMarker(null);
    setSelectedPath([]);
    setIsTrackSelected(false);
    setSelectedDot(null);
    setShowTrackingWithActivity(false);
    setIsOpen(false);
    setInfoWindowData(null);
    setHomeMarker(null);
  };

  const onChangeCheckbox = (newValue, currentValue, salesTeamData) => {
    const effectiveValue = newValue == null ? currentValue : newValue;

    setCheckboxValue(effectiveValue);

    if (effectiveValue == 0) {
      setShowTrackingWithActivity(false);
      if (currentValue != 2 && currentValue != 3 && currentValue != 4) {
        handleMarkerClick({
          id: personMarkers[0]?.id,
          logs: personMarkers[0]?.logs,
        });
      }

      setOutletMarkers([]);
      setOutletPath([]);
      setSelectedDot(null);
      setHomeMarker(null);
    } else if (effectiveValue == 1) {
      handleOutletsClick();
      setSelectedMarker(null);
      setSelectedPath([]);
      setSelectedDot(null);
      setShowTrackingWithActivity(false);
      setHomeMarker(null);
    } else if (effectiveValue == 2) {
      const isSelecting = newValue !== null;
      setShowTrackingWithActivity(isSelecting);
      if (currentValue != 0 && currentValue != 3 && currentValue != 4) {
        handleMarkerClick({
          id: personMarkers[0]?.id,
          logs: personMarkers[0]?.logs,
        });
      }
      setOutletMarkers([]);
      setOutletPath([]);
      setSelectedDot(null);
      setHomeMarker(null);
    } else if (effectiveValue == 3) {
      if (currentValue != 0 && currentValue != 2 && currentValue != 4) {
        handleMarkerClick({
          id: personMarkers[0]?.id,
          logs: personMarkers[0]?.logs,
        });
      }
      const gapPoints = selectedPath
        .filter((point) => point.isGap)
        .map((point, index) => ({ ...point, index }));

      const isSelecting = newValue !== null;
      setShowTrackingWithActivity(isSelecting);
      setOutletMarkers([]);
      setHideOnLoadTimeDelayPopUp(false);
      setHomeMarker(null);
    } else if (effectiveValue == 4) {

      if (currentValue != 0 && currentValue != 2 && currentValue != 3) {
        handleMarkerClick({
          id: personMarkers[0]?.id,
          logs: personMarkers[0]?.logs,
        });
      }

      const lat = parseFloat(salesTeamData?.salesTeamLatitude);
      const lng = parseFloat(salesTeamData?.salesTeamLongitude);
      const isSelecting = newValue !== null;

      if (!isNaN(lat) && !isNaN(lng) && isSelecting) {
        setHomeMarker({
          lat,
          lng,
          salesTeamHomeAddress: salesTeamData?.salesTeamHomeAddress || "",
        });
        mapRef?.panTo({ lat, lng });
        mapRef?.setZoom(15);
      } else {
        setHomeMarker(null);
      }

      setShowTrackingWithActivity(isSelecting);
      setSelectedDot(null);
      setOutletMarkers([]);
      setOutletPath([]);
    }
  };

  const tabValueHandler = (value, rows) => {
    let filterDaylist = [];
    if (showTimelineManagerLogs == 0 && params.userTypeId == "4") {
      filterDaylist =
        timelineDataForManager.length !== 0
          ? timelineDataForManager.filter((row) => row.index == value)
          : [];
      if (filterDaylist.length !== 0) {
        fetchInitialMapData(filterDaylist[0].date);
      }
    } else {
      filterDaylist =
        rows.length !== 0 ? rows.filter((row) => row.index == value - 1) : [];
      if (filterDaylist.length !== 0) {
        const pickedDate = filterDaylist[0].date;
        setSelectedDate(pickedDate);
      }
      let firebaseList = [];
      if (filterDaylist.length !== 0 && filterDaylist[0].managerLogs) {
        filterDaylist[0].managerLogs
          .filter((row) => row.flag == 1)
          .forEach((locObject, index) => {
            const locData = {
              index: index + 1,
              id: locObject.id,
              name: filterDaylist[0].name || locObject.name || "-",
              address:
                locObject.checkInOut == 1
                  ? locObject.endAddress
                  : locObject.startAddress,
              lat:
                locObject.checkInOut == 1
                  ? +locObject.managerEndLat
                  : +locObject.managerStartLat,
              lng:
                locObject.checkInOut == 1
                  ? +locObject.managerEndLong
                  : +locObject.managerStartLong,
              icon:
                locObject.otherTaskId != null
                  ? locObject.otherTaskId == 1
                    ? locObject.isVisitIsOrder == 0
                      ? retailingImg
                      : zeroOrderIconImg
                    : locObject.otherTaskId == 2 &&
                      locObject.workingTypeId !== 5
                      ? distributorImg
                      : locObject.otherTaskId == 3
                        ? officeWorkImg
                        : locObject.otherTaskId == 4
                          ? jointWorkImg
                          : locObject.otherTaskId == 5 && locObject.checkInOut == 0
                            ? checkInImg
                            : locObject.otherTaskId == 5 && locObject.checkInOut == 1
                              ? checkOutImg
                              : otherWorkImg
                  : "",
              amount:
                locObject.isVisitIsOrder == 0
                  ? !isNaN(parseFloat(locObject.description)) &&
                    isFinite(locObject.description)
                    ? parseFloat(locObject.description).toFixed(2)
                    : "0"
                  : "0",
              workingTypeId: locObject.workingTypeId,
              startTime: locObject.fromTime,
              endTime: locObject.toTime,
              outletName: locObject.entityName,
              remoteOrder: locObject.remoteOrder,
              checkInOut: locObject.checkInOut,
              outletLat: locObject.outletLatitude,
              outletLong: locObject.outletLongitude,
            };
            firebaseList.push(locData);
          });
      }

      const latestLog = firebaseList[firebaseList.length - 1] || {
        lat: checkInLat,
        lng: checkInLong,
      };
      const personMarker = {
        id: filterDaylist[0].id,
        name: filterDaylist[0].name,
        lat: latestLog.lat,
        lng: latestLog.lng,
        logs: filterDaylist[0].managerLogs,
        employeeCode: filterDaylist[0].employeeCode,
        icon: filterDaylist[0].id == params.id ? uniqueUser : newUsers,
      };

      setPersonMarkers([personMarker]);
      setActivityMarkers(firebaseList);
      setTimelineDataForManager(filterDaylist);

      if (filterDaylist[0].managerLogs.length == 0) {
        setPersonMarkers([]);
      }
      setOpenInfoWindows([personMarker.id]);
      setTimelineAndMapOpenFlag(true);

      setOutletMarkers([]);
      setOutletPath([]);
      handleMarkerClick([]);
      setSelectedMarker(null);
      setSelectedPath([]);
      setIsTrackSelected(false);
      setSelectedDot(null);
      setShowTrackingWithActivity(false);
      setIsOpen(false);
      setInfoWindowData(null);
    }
  };

  return (
    <Paper sx={{ borderRadius: 2, p: 1, height: mainHeight }}>
      <Grid container spacing={2} sx={{ height: "100%" }}>
        <Grid item xs={8} sx={{ height: "100%" }}>
          {!isLoaded ? (
            <h1>Loading...</h1>
          ) : (
            <GoogleMap
              mapContainerStyle={{
                width: "100%",
                height: mapHeight,
                position: "relative",
              }}
              onLoad={onMapLoad}
            >
              {personMarkers.map((marker) => (
                <Marker
                  key={marker.id}
                  position={{ lat: marker.lat, lng: marker.lng }}
                  icon={{
                    url: marker.icon,
                    scaledSize:
                      marker.scaledSize || new window.google.maps.Size(80, 80),
                  }}
                  onClick={() => handleMarkerClicks(marker)}
                >
                  {/* {openInfoWindows.includes(marker.id) &&
                    (marker.icon === uniqueUser || marker.icon === newUsers) &&
                    marker.logs &&
                    marker.logs.length > 0 && (
                      <OverlayView
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        position={{ lat: marker.lat, lng: marker.lng }}
                        getPixelPositionOffset={(width, height) => ({
                          y: -(height / 3),
                        })}
                      >
                        <div
                          style={{
                            backgroundColor: "white",
                            borderRadius: "10px",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                            padding: "0px",
                            width: "220px",
                            fontFamily: "Arial, sans-serif",
                            overflow: "visible",
                            position: "relative",
                            transform: "translate(-50%, -100%)",
                            pointerEvents: "auto",
                            zIndex: 9999,
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "black",
                              color: "white",
                              padding: "20px 12px 30px",
                              textAlign: "center",
                              position: "relative",
                            }}
                          >
                            <button
                              onClick={() =>
                                setOpenInfoWindows((prev) =>
                                  prev.filter((id) => id !== marker.id)
                                )
                              }
                              style={{
                                position: "absolute",
                                right: "8px",
                                top: "8px",
                                background: "#5aa9fb",
                                border: "none",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "14px",
                                fontWeight: "bold",
                                cursor: "pointer",
                                border: "2px solid #eaf1ebff",
                              }}
                            >
                              X
                            </button>

                            <div
                              style={{
                                backgroundColor: "#4dd0e1",
                                borderRadius: "50%",
                                width: "50px",
                                height: "50px",
                                margin: "0 auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                position: "absolute",
                                left: "50%",
                                bottom: "-20px",
                                transform: "translateX(-50%)",
                              }}
                            >
                              <LocationOnIcon
                                style={{ fontSize: "30px", color: "white" }}
                              />
                            </div>
                          </div>

                          <div style={{ padding: "12px", textAlign: "center" }}>
                            <h4
                              style={{
                                margin: "8px 0 4px",
                                fontSize: "13px",
                                fontWeight: "bold",
                              }}
                            >
                              {marker.name || "-"}
                            </h4>

                            <p
                              style={{
                                margin: "0",
                                fontSize: "13px",
                                color: "#555",
                              }}
                            >
                              {marker.lat}, {marker.lng}
                            </p>

                            <hr style={{ margin: "10px 0" }} />

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginTop: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: "none",
                                  border: "none",
                                  color:
                                    isTrackSelected == marker.id
                                      ? "blue"
                                      : "gray",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                  fontWeight:
                                    isTrackSelected == marker.id
                                      ? "bold"
                                      : "normal",
                                }}
                                onClick={() => {
                                  setIsTrackSelected(
                                    isTrackSelected == marker.id
                                      ? null
                                      : marker.id
                                  );
                                  handleMarkerClick({
                                    id: marker.id,
                                    logs: marker.logs,
                                  });
                                }}
                              >
                                <DirectionsWalkIcon fontSize="small" /> Tracking
                              </button>
                            </div>
                          </div>

                          <div
                            style={{
                              position: "absolute",
                              bottom: "-20px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              width: 0,
                              height: 0,
                              borderLeft: "12px solid transparent",
                              borderRight: "12px solid transparent",
                              borderTop: "20px solid white",
                            }}
                          />
                        </div>
                      </OverlayView>
                    )} */}
                </Marker>
              ))}

              {selectedPath.length > 1 &&
                getTimeBetweenCords(selectedPath).map((seg, id) => (
                  <Polyline
                    key={id}
                    path={seg.coords}
                    options={{
                      strokeColor: seg.color,
                      strokeOpacity: 0.8,
                      strokeWeight: 3,
                      // icons: [
                      //   {
                      //     icon: {
                      //       path: window.google.maps.SymbolPath
                      //         .FORWARD_CLOSED_ARROW,
                      //       scale: 3,
                      //       strokeColor: "black",
                      //       strokeWeight: 2,
                      //     },
                      //     offset: "100%",
                      //     repeat: "50px",
                      //   },
                      // ],
                    }}
                  />
                ))}

              {timelineAndMapOpenFlag &&
                showTrackingWithActivity &&
                activityMarkers.map(
                  (
                    {
                      index,
                      address,
                      lat,
                      lng,
                      id,
                      icon,
                      flag,
                      amount,
                      workingTypeId,
                      startTime,
                      endTime,
                      outletName,
                      insertTime,
                      remoteOrder,
                      checkInOut,
                      outletLat,
                      outletLong,
                      mid,
                      bearing,
                      durationMinutes,
                    },
                    ind
                  ) => {
                    if (!lat || !lng) return null;

                    const isFaded =
                      selectedActivities.length > 0 &&
                      !selectedActivities.includes(icon);

                    return (
                      <>
                        {flag ? (
                          <>
                            {activityMarkers.map((locData, ind) => {
                              const next = activityMarkers[ind + 1];

                              return (
                                <>
                                  {locData.flag && locData.mid && (
                                    <Marker
                                      position={{
                                        lat: locData.mid.lat,
                                        lng: locData.mid.lng,
                                      }}
                                    // icon={{
                                    //   path: window.google.maps.SymbolPath
                                    //     .FORWARD_CLOSED_ARROW,
                                    //   scale: 3,
                                    //   strokeColor: "blue",
                                    //   rotation: locData.bearing,

                                    //   strokeOpacity: 1,
                                    // }}
                                    />
                                  )}

                                  {(() => {
                                    const isShowTimelineMapStoppage =
                                      localStorage.getItem(
                                        "isShowTimelineMapStoppage"
                                      );
                                    const stoppageObj =
                                      isShowTimelineMapStoppage
                                        ? JSON.parse(isShowTimelineMapStoppage)
                                        : {};
                                    const stopMin =
                                      (stoppageObj?.stoptime || 0) / 60;
                                    const start = dayjs(
                                      locData.insertTime,
                                      "HH:mm:ss"
                                    );
                                    const end = dayjs(
                                      next?.insertTime,
                                      "HH:mm:ss"
                                    );
                                    const diffMinutes = end.diff(
                                      start,
                                      "minute"
                                    );
                                    let shouldDrawRed = false;
                                    if (stoppageObj.identify_stops == true) {
                                      if (
                                        (!stoppageObj.withActivity &&
                                          locData.flag == 0 &&
                                          next?.flag == 0) ||
                                        stoppageObj.withActivity
                                      ) {
                                        if (diffMinutes > stopMin) {
                                          shouldDrawRed = true;
                                        }
                                      }
                                    }
                                    return (
                                      next &&
                                      shouldDrawRed && (
                                        <Polyline
                                          path={[
                                            {
                                              lat: locData.lat,
                                              lng: locData.lng,
                                            },
                                            { lat: next.lat, lng: next.lng },
                                          ]}
                                          options={{
                                            strokeColor: "red",

                                            strokeOpacity: 1,
                                            strokeWeight: 2,
                                          }}
                                        />
                                      )
                                    );
                                  })()}
                                </>
                              );
                            })}

                            <Marker
                              key={id || ind}
                              position={{ lat, lng }}
                              icon={{
                                path: window.google.maps.SymbolPath.CIRCLE,
                                scale: 6,
                                fillColor: "#fff",
                                fillOpacity: 1,
                                strokeColor: "#000",
                                strokeWeight: 2,
                                strokeOpacity: 1,
                              }}
                              onClick={() =>
                                handleMarkerClick({
                                  id,
                                  logs:
                                    timelineDataForManager[0]?.managerLogs ||
                                    [],
                                })
                              }
                            >
                              {isOpen && infoWindowData?.id === (id ?? ind) && (
                                <InfoWindow
                                  position={{ lat, lng }}
                                  onCloseClick={() => setIsOpen(false)}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "6px",
                                    }}
                                  >
                                    <div style={timelineStyles.dataSection}>
                                      <span style={timelineStyles.span}>
                                        {"Activity No. : " + index}
                                      </span>
                                      <span style={timelineStyles.span}>
                                        {checkInOut == 0
                                          ? "Check In Time : " + startTime
                                          : "Check Out Time : " + endTime}
                                      </span>
                                      <span style={timelineStyles.span}>
                                        {checkInOut == 0
                                          ? "Check In Address : " +
                                          checkInAddress
                                          : "Check Out Address : " +
                                          checkInAddress}
                                      </span>
                                    </div>
                                  </div>
                                </InfoWindow>
                              )}
                            </Marker>
                          </>
                        ) : (
                          <Marker
                            key={id || ind}
                            position={{ lat, lng }}
                            anchor={{ x: 0.5, y: 0.5 }}
                            opacity={isFaded ? 0 : 1}
                            icon={{
                              url: icon,
                              scaledSize: new window.google.maps.Size(50, 50),
                            }}
                            onClick={() =>
                              handleIconMarkerClick({
                                index,
                                id,
                                lat,
                                lng,
                                address,
                                amount,
                                workingTypeId,
                                startTime,
                                endTime,
                                outletName,
                                insertTime,
                                remoteOrder,
                                checkInOut,
                                outletLat,
                                outletLong,
                              })
                            }
                          >
                            {isOpen && infoWindowData?.id === (id ?? ind) && (
                              <InfoWindow
                                position={{ lat, lng }}
                                onCloseClick={() => setIsOpen(false)}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "6px",
                                  }}
                                >
                                  {infoWindowData.workingTypeId == 5 ? (
                                    <div style={timelineStyles.dataSection}>
                                      <span style={timelineStyles.span}>
                                        {"Activity No. : " + index}
                                      </span>
                                      <span style={timelineStyles.span}>
                                        {infoWindowData.checkInOut == 0
                                          ? "Check In Time : " + startTime
                                          : "Check Out Time : " + endTime}
                                      </span>
                                      <span style={timelineStyles.span}>
                                        {infoWindowData.checkInOut == 0
                                          ? "Check In Address : " +
                                          checkInAddress
                                          : "Check Out Address : " +
                                          checkInAddress}
                                      </span>
                                    </div>
                                  ) : infoWindowData.workingTypeId ==
                                    undefined ||
                                    infoWindowData.workingTypeId == "" ||
                                    infoWindowData.workingTypeId == null ? (
                                    <div style={timelineStyles.dataSection}>
                                      <span style={timelineStyles.span}>
                                        {infoWindowData.insertTime}
                                      </span>
                                    </div>
                                  ) : (
                                    <div style={timelineStyles.dataSection}>
                                      <span style={timelineStyles.span}>
                                        {"Activity No. : " + index}
                                      </span>
                                      <span style={timelineStyles.span}>
                                        {"Outlet Name : " + outletName}
                                      </span>
                                      <span style={timelineStyles.span}>
                                        {"Outlet Address : " + address}
                                      </span>
                                      <span style={timelineStyles.span}>
                                        {"Is Remote Order : " +
                                          (remoteOrder == 0 ? "No" : "Yes")}
                                      </span>
                                      {showDistanceFromOutlet && (
                                        <span style={timelineStyles.span}>
                                          {"Order Distance : " +
                                            (+distanceFromOutlet).toFixed(2) +
                                            " Meter"}
                                        </span>
                                      )}
                                      <span style={timelineStyles.span}>
                                        {"Order Amount : " + amount}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </InfoWindow>
                            )}
                          </Marker>
                        )}
                      </>
                    );
                  }
                )}

              {selectedPath.map((point, index) => (
                <>
                  <>
                    <Marker
                      key={index}
                      position={{ lat: point.lat, lng: point.lng }}
                      icon={{
                        url: locationMan,
                        scaledSize: new window.google.maps.Size(15, 15),
                        anchor: new window.google.maps.Point(5, 12),
                      }}
                      onClick={async () => {
                        setSelectedDot(point);
                        setDotAddress("");
                        //Comment BY Tejas - 21-03-2026
                        // if (point?.gapTime > 60) {
                        const address = await checkInOutAddressHandler({
                          managerStartLat: point.lat,
                          managerStartLong: point.lng,
                        });
                        setDotAddress(address);
                        // }
                      }}
                    />
                  </>
                </>
              ))}

              {selectedDot && (
                <InfoWindow
                  position={{ lat: selectedDot.lat, lng: selectedDot.lng }}
                  onCloseClick={() => {
                    setSelectedDot(null);
                    setDotAddress("");
                  }}
                >
                  <div>
                    {selectedDot.isGap ? (
                      <>
                        {/* Time Delay */}
                        <div style={timelineStyles.row}>
                          <TypographyCompo sx={timelineStyles.label}>
                            Time Delay :
                          </TypographyCompo>

                          <TypographyCompo sx={timelineStyles.value}>
                            {Math.round(selectedDot.gapTime)} mins from Last Location
                          </TypographyCompo>
                        </div>

                        {/* Time */}
                        <div style={timelineStyles.row}>
                          <TypographyCompo sx={timelineStyles.label}>
                            Time :
                          </TypographyCompo>

                          <TypographyCompo sx={timelineStyles.value}>
                            {selectedDot.insertTime}
                          </TypographyCompo>
                        </div>

                        {/* Address */}
                        {selectedDot.gapTime > 60 && (
                          <div style={timelineStyles.row}>
                            <TypographyCompo sx={timelineStyles.label}>
                              Address :
                            </TypographyCompo>

                            <TypographyCompo sx={timelineStyles.value}>
                              {dotAddress || fetchingAddressMsg}
                            </TypographyCompo>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div style={timelineStyles.row}>
                          <TypographyCompo sx={timelineStyles.label}>
                            Time :
                          </TypographyCompo>

                          <TypographyCompo sx={timelineStyles.value}>
                            {selectedDot.insertTime}
                          </TypographyCompo>
                        </div>
                        <div style={timelineStyles.row}>
                          <TypographyCompo sx={timelineStyles.label}>
                            Address :
                          </TypographyCompo>

                          <TypographyCompo sx={timelineStyles.value}>
                            {dotAddress || fetchingAddressMsg}
                          </TypographyCompo>
                        </div>
                      </>
                    )}
                  </div>
                </InfoWindow>
              )}

              {outletMarkers.map((outlet, index) => (
                <Marker
                  key={outlet.id}
                  position={{ lat: outlet.lat, lng: outlet.lng }}
                  icon={{
                    url: outlet.icon,
                    scaledSize: new window.google.maps.Size(40, 40),
                  }}
                  onClick={() => {
                    setSelectedOutletId(outlet.id);
                  }}
                >
                  {selectedOutletId === outlet.id && (
                    <InfoWindow
                      position={{ lat: outlet.lat, lng: outlet.lng }}
                      onCloseClick={() => setSelectedOutletId(null)}
                    >
                      <div>
                        <strong>{outlet.firmName}</strong>
                        <br />
                        <span>Code: {outlet.outletCode || "-"}</span>
                      </div>
                    </InfoWindow>
                  )}
                </Marker>
              ))}

              {homeMarker && (
                <Marker
                  position={{ lat: homeMarker.lat, lng: homeMarker.lng }}
                  icon={{
                    url: houseImg,
                    scaledSize: new window.google.maps.Size(50, 50),
                    anchor: new window.google.maps.Point(20, 20),
                  }}
                  onClick={() =>
                    setHomeMarker((prev) => ({ ...prev, isOpen: !prev.isOpen }))
                  }
                >
                  {homeMarker.isOpen && (
                    <InfoWindow
                      position={{ lat: homeMarker.lat, lng: homeMarker.lng }}
                      onCloseClick={() =>
                        setHomeMarker((prev) => ({ ...prev, isOpen: false }))
                      }
                    >
                      <div style={timelineStyles.row}>
                        <TypographyCompo sx={timelineStyles.label}>Home Address :</TypographyCompo>
                        <TypographyCompo sx={timelineStyles.value}>{homeMarker.salesTeamHomeAddress || addressNotAvailableMsg}</TypographyCompo>
                      </div>
                    </InfoWindow>
                  )}
                </Marker>
              )}

              {outletPath.length > 1 && (
                <Polyline
                  path={outletPath}
                  options={{
                    strokeColor: "green",
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                  }}
                />
              )}
              {checkboxValue == 3 &&
                !hideOnLoadTimeDelayPopUp &&
                selectedPath
                  .filter((point) => point.isGap)
                  .map((point, index) => (
                    <InfoWindow
                      key={`gap-${index}`}
                      position={{ lat: point.lat, lng: point.lng }}
                      onCloseClick={() => setSelectedDot(null)}
                    >
                      <div style={{ fontSize: 13, padding: 4 }}>
                        <strong>Time Delay:</strong>{" "}
                        {Math.round(point?.gapTime || "-")} mins from Last
                        Location
                        <br />
                        <strong>Time:</strong> {point?.insertTime || "-"}
                      </div>
                    </InfoWindow>
                  ))}
            </GoogleMap>
          )}
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            height: "100%",
            overflow: "auto",
          }}
        >
          <Timeline
            handleTabData={handleTabData}
            onSearchData={onSearchData}
            onInitialTimelineData={handleInitialTimelineData}
            saveData={tabValueHandler}
            onChangeCheckbox={onChangeCheckbox}
            onActivitySelect={onActivitySelect}
            pathCoords={timelinePathCoords}
            handleTabDataForTimeDelay={handleTabDataForTimeDelay}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

const timelineStyles = {
  span: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    alignItems: "flex-start",
    fontSize: "15px",
    fontWeight: "400",
  },
  dataSection: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "flex-start",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    width: "100%",
  },
  label: {
    minWidth: "80px",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
  value: {
    flex: 1,
    wordBreak: "break-word",
  },

};

const mapStateToProps = (state) => ({
  location: state.location,
});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  getTimeLineForBelowSalesTeamsAndDates,
  getDateWiseBeatAndOutlets,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GMapWithFunctionality);
